var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.200195,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#9ACA3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2002 6C14.2591 6 6.2002 14.0589 6.2002 24C6.2002 33.9411 14.2591 42 24.2002 42C34.1413 42 42.2002 33.9411 42.2002 24C42.2002 14.0589 34.1413 6 24.2002 6ZM2.2002 24C2.2002 11.8497 12.0499 2 24.2002 2C36.3505 2 46.2002 11.8497 46.2002 24C46.2002 36.1503 36.3505 46 24.2002 46C12.0499 46 2.2002 36.1503 2.2002 24Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2002 16C26.2002 14.8954 25.3048 14 24.2002 14C23.0956 14 22.2002 14.8954 22.2002 16V22H16.2002C15.0956 22 14.2002 22.8954 14.2002 24C14.2002 25.1046 15.0956 26 16.2002 26H22.2002V32C22.2002 33.1046 23.0956 34 24.2002 34C25.3048 34 26.2002 33.1046 26.2002 32V26H32.2002C33.3048 26 34.2002 25.1046 34.2002 24C34.2002 22.8954 33.3048 22 32.2002 22H26.2002V16ZM26.2002 22H22.2002V26H26.2002V22Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2002 22H22.2002V26H26.2002V22Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.abe07b2ed2b0899a0effa6906ccc5644.svg";
export { ForwardRef as ReactComponent };